import React from "react";
import { FieldValues, UseFormReturn } from "react-hook-form";
import { LovInput, SibaInput } from "@siba/components";
import { Stack } from "@mui/material";
import { ExternalBid } from "Application/features/models/Home/ExternalBid";
import { useGetAllCurrenciesMutation } from "../../../features/services/apis/Home/SalvageExternalApiService";
interface BidUpdateformInterface {
    formHandler: UseFormReturn<FieldValues, object>;
    bid: ExternalBid;
}
const BidUpdateForm: React.FC<BidUpdateformInterface> = (props) => {
    const { formHandler, bid } = props;
    const [getAllCurrenciesLov] = useGetAllCurrenciesMutation();
    return (
        <div style={{ padding: "1em" }}>
            <Stack direction="column" spacing={2}>
                <SibaInput name="BidderCode" label="Bidder Code" value={bid.BidderCode} validationObj={{ required: false }} formHandler={formHandler as any} disabled={true} />
                <SibaInput name="BidderName" label="Bidder Name" value={bid.BidderCode} validationObj={{ required: false }} formHandler={formHandler as any} disabled={true} />
                <SibaInput name="PhoneNumber" label="Phone Number" value={bid.PhoneNumber} validationObj={{ required: false }} formHandler={formHandler as any} disabled={true} />
                <SibaInput name="Email" label="Email" value={bid.Email} validationObj={{ required: false }} formHandler={formHandler as any} disabled={true} />
                <SibaInput name="Address" label="Address" value={bid.Address} validationObj={{ required: false }} formHandler={formHandler as any} disabled={true} />
                <LovInput
                    CodeField="Currency"
                    NameField="Currency"
                    formHandler={formHandler as any}
                    handleFetch={getAllCurrenciesLov}
                    label="Currency"
                    validationObj={{ required: true }}
                    hideCode={true}
                    callBack={(row: any) => {
                        formHandler.setValue("Currency", row.CODE);
                    }}
                />
                <SibaInput name="BidAmount" type="number" label="Bid Amount" validationObj={{ required: true }} formHandler={formHandler as any} />
            </Stack>
        </div>
    );
};

export default BidUpdateForm;
